import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AsYouType, CountryCode} from 'libphonenumber-js';

@Directive({
    selector: '[appPhoneMask]',
    standalone: false
})
export class PhoneMaskDirective {
  @Input('countryCode') countryCode: string;

  constructor(public ngControl: NgControl) {}

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    if (event) {
      this.onInputChange(event.number, false);
    }
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
  }

  onInputChange(event, backspace) {
    let asYouType: AsYouType = this.getFormatter();

    if (asYouType) {
      let newVal = event.replace(/\D/g, '');

      if (backspace && newVal.length <= 6) {
        newVal = newVal.substring(0, newVal.length - 1);
      }

      newVal = asYouType.input(newVal);
      if (this.ngControl.value?.number != newVal) {
        isNaN(this.ngControl.value?.number.slice(-1))
          ? this.ngControl.valueAccessor.writeValue(newVal)
          : setTimeout(() => this.ngControl.valueAccessor.writeValue(newVal));
      }
    }
  }

  private getFormatter(): AsYouType {
    return ['us', 'jp', 'ca', 'ph', 'mx', 'be', 'lu', 'de', 'br'].includes(
      this.countryCode
    )
      ? new AsYouType(this.countryCode.toUpperCase() as CountryCode)
      : null;
  }
}
